import React from 'react'

const ThunderIcon = props => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_3980_39117)'>
      <path
        d='M10.8665 5.44962C10.786 5.3245 10.6478 5.25012 10.4999 5.25012H7.43744V0.437685C7.43744 0.231188 7.29307 0.0526903 7.09095 0.00981585C6.88533 -0.0339336 6.68408 0.07194 6.60008 0.260063L3.10013 8.13496C3.03976 8.26971 3.05288 8.42721 3.13338 8.55058C3.21388 8.67483 3.35213 8.75008 3.5 8.75008H6.56246V13.5625C6.56246 13.769 6.70683 13.9475 6.90895 13.9904C6.93957 13.9965 6.9702 14 6.99995 14C7.1697 14 7.32807 13.9011 7.39982 13.7401L10.8998 5.86524C10.9593 5.72962 10.9479 5.57387 10.8665 5.44962Z'
        fill='#FFC600'
      />
    </g>
    <defs>
      <clipPath id='clip0_3980_39117'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default ThunderIcon
